// export const API_BASE_URL = 'http://127.0.0.1:8000';
export const API_BASE_URL = 'https://vapira.ru/api'

export const SHOW_AI_STORE_SETUP = false;
export const SHOW_MAPS = true;
export const SHOW_POINT = false
export const SHOW_CATALOG_RATING = false;

export const QR_ACCENT_COLOR = '#A8E10C';


// Наклон превью каталога с выравниванием при наведении.
export const SPECIAL_POSITION = true;

// Предпросмотр ссылок с метаданными внешних сервисов.
export const isPrewiew = false;
